import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
const points = ['Te levantás con el abdomen ya pesado, antes de haber comido nada.', 'Comés poco y sano, pero igual terminás hinchada.', 'Probaste eliminar cosas, pero sin orden y sin resultados claros.', 'Te dijeron “es la edad” o “es el estrés”, pero nadie te dio herramientas concretas.', 'Dejaste de ponerte ropa ajustada porque la incomodidad ya forma parte de tu día.'];
export function PainPoints() {
  return <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-86" data-mp="220ebp66l1sfe">
      <div className="mx-auto max-w-4xl" data-id="element-87" data-mp="1nztpe01gleh5">
        <header className="text-center" data-id="element-88" data-mp="1o0vc51ru7pep">
          <h2 className="font-display text-3xl font-bold sm:text-5xl" style={{
          fontSize: "24px"
        }} data-id="element-89" data-mp="1o1wpxe08mq04">
            ¿Cuánto tiempo más vas a terminar cada comida sintiéndote incómoda con tu propio cuerpo?
          </h2>
          <p className="mx-auto mt-6 max-w-3xl text-slate-300" data-id="element-90" data-mp="3ncfmwfwm4d3k">
            Sos una mujer activa, organizada y que cuida a los demás. Pero hay algo que te molesta hace tiempo y que nadie supo explicarte bien.
          </p>
          <p className="mt-4 font-semibold text-brand-light" data-id="element-91" data-mp="1u2dfa6kld0tb">
            No es tu culpa. Es que te faltaba un sistema claro.
          </p>
        </header>
        <div className="mt-10 space-y-3" data-id="element-92" data-mp="27utcgqqta4mb">
          {points.map((point, index) => <motion.div key={point} initial={{
          opacity: 0,
          x: -14
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="flex gap-3 rounded-xl border border-red-900/70 bg-[#250c0c] p-4 sm:p-5" data-id="element-93" data-mp="23thwlcxqoxrb" data-mpi={index}>
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" aria-hidden="true" data-id="element-94" data-mp="1k34qrt8hweec" />
              <p className="text-sm leading-relaxed text-slate-200 sm:text-base" data-id="element-95" data-mp="30guxz8uwvis7">{point}</p>
            </motion.div>)}
        </div>
        <p className="mt-12 text-center font-display text-2xl font-bold italic text-brand-gold sm:text-3xl" style={{
        fontSize: "20px"
      }} data-id="element-96" data-mp="2vibah40o5yxq">
          ¿Y si pudieras tener un mapa simple para empezar a sentirte más liviana desde esta semana?
        </p>
      </div>
    </section>;
}